import React from 'react';
import { Flex, Image, Text } from '@chakra-ui/react';

import colors from '../../../styles/theme/foundation/colors';
import underConstructionImage from '../../../under-construction.png';

function EmailTemplates() {
  return (
    <Flex
      alignItems="center"
      flexDirection="column"
      height="100%"
      justifyContent="center"
      py={4}
    >
      <Image src={underConstructionImage} />
      <Text color={colors.greyScale['600']} py="2rem" textStyle="displayXs600">
        Email Templates Coming Soon!
      </Text>
    </Flex>
  );
}

export default EmailTemplates;
